import { HttpClient } from '@angular/common/http';
import { Component, effect, inject } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-health-check',
  template: '<p>Ping pong</p>',
  styleUrls: [],
  imports: [],
})
export class HealthCheck {
  private http = inject(HttpClient);

  constructor() {
    effect(() => {
      this.http
        .patch<void>(
          `${environment.baseUrl}/api/v1/participacoes/teste/cros`,
          {}
        )
        .subscribe({
          next: () => console.log('ping pong'),
          error: (error) => console.log('ping pong error:', error),
        });
    });
  }
}
